
import { useStripe } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useUser } from "../context/useInfo";
import amplitude from "../utils/amplitude";

export default function ApplePayButton() {
  const stripe = useStripe();
  const { userData } = useUser();
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [canMakePayment, setCanMakePayment] = useState(false);
  const option = userData.selectedOption;

  useEffect(() => {
    if (!stripe || !option) return;

    const amount = Math.round(
      parseFloat(option.discount.replace(/[^0-9.-]+/g, "")) * 100
    );

    const pr = stripe.paymentRequest({
      country: "US",
      currency: "usd",
      total: {
        label: option.title,
        amount: amount,
      },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    pr.canMakePayment().then(result => {
      setCanMakePayment(!!result);
      if (result) setPaymentRequest(pr);
    });

    pr.on("paymentmethod", async (event) => {
      try {
        const email = event.payerEmail || userData.email;

        // 1) Создаем SetupIntent
        const setupRes = await fetch(
          "https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/createSetupIntent",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
          }
        );

        if (!setupRes.ok) throw new Error("Failed to create setup intent");
        const { clientSecret: setupClientSecret } = await setupRes.json();

        // 2) Подтверждаем Apple Pay как SetupIntent
        const { setupIntent, error: setupError } = await stripe.confirmCardSetup(setupClientSecret, {
          payment_method: event.paymentMethod.id,
        });

        if (setupError) {
          event.complete("fail");
          return alert(`Setup failed: ${setupError.message}`);
        }
        console.log("✅ Payment method attached:", setupIntent.payment_method);


        // 3) Создаем подписку
        const subRes = await fetch(
          "https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/createSubscription",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              priceId: option.price_id,
              email,
              paymentMethodId: setupIntent.payment_method,
            }),
          }
        );

        
        if (!subRes.ok) {
          const errorData = await subRes.json();
          throw new Error(errorData.error || "Failed to create subscription");
        }


        const { clientSecret: paymentClientSecret } = await subRes.json();

        // 4) Подтверждаем платеж, если нужно
        if (paymentClientSecret) {
          const { error: paymentError } = await stripe.confirmCardPayment(paymentClientSecret);
          if (paymentError) {
            event.complete("fail");
            if (process.env.NODE_ENV === "production") {
              amplitude.track("Payment Failed Apple Pay", { email });
            }
            return alert(`Payment failed: ${paymentError.message}`);
          }
        }

        event.complete("success");

        if (process.env.NODE_ENV === "production") {
          amplitude.track("Payment Success Apple Pay", { email });
        }

        window.location.href = "/prediction/subscribe-success";
      } catch (err) {
        event.complete("fail");
        alert(`Subscription failed: ${err.message}`);
      }
    });

    setPaymentRequest(pr);
  }, [stripe, option, userData]);

  if (!canMakePayment || !paymentRequest) return null;

  // Кастомная кнопка вместо встроенного iframe
  return (
    <div className="flex w-full justify-center mt-5 mb-5">
      <button
        className="bg-black w-full text-white px-6 py-3 rounded-full hover:brightness-110 transition"
        onClick={async () => {
          if (!paymentRequest) return;
          // Ловим клик и отправляем событие
          if (process.env.NODE_ENV === "production") {
            amplitude.track("Apple Pay Button Clicked", { email: userData.email });
          }
          // Открываем Apple Pay sheet
          await paymentRequest.show();
        }}
      >
        Pay with Apple Pay
      </button>
    </div>
  );
}
